import { useState } from "react";

export const useFields = () => {
    const [fields, setFields] = useState<ICalculatorField[]>([
        { label: 'клейковина ≥', id: 0, enabled: true, value: 'gluten' },
        { label: 'ИДК ≤', id: 1, enabled: true, value: 'idk' },
        { label: 'клоп ≤', id: 2, enabled: false, value: 'clop' },
        { label: 'протеин ≥', id: 3, enabled: true, value: 'protein' },
        { label: 'ЧП ≥', id: 4, enabled: true, value: 'cp' },
        { label: 'натура ≥', id: 5, enabled: true, value: 'nature' },
        { label: 'влажность ≤', id: 6, enabled: false, value: 'humidity' },
      ]);

    return { fields, setFields };
}

export interface ICalculatorField {
    label: string,
    id: number,
    enabled: boolean,
    value: string
}